// extracted by mini-css-extract-plugin
module.exports = {"noPointerEvents":"LobbyPromo_noPointerEvents__TPWis","bottomWrapper":"LobbyPromo_bottomWrapper__yi3Kx","bgPlanet":"LobbyPromo_bgPlanet__V16JK"};